export const GET_PROFILE_DETAILS = "profile";
export const GET_PROFILE_IMAGE = "profile_image";
export const UPDATE_PROFILE_IMAGE = "profile_image/update";
export const UPDATE_PROFILE = "profile/update";
export const UPLOAD_FILE = "fileupload";
export const UPDATE_PASSWORD = "chanage_password";
